import { render } from "./announcement_editor.vue?vue&type=template&id=357f0d7c"
import script from "./announcement_editor.js?vue&type=script&lang=js&external"
export * from "./announcement_editor.js?vue&type=script&lang=js&external"

import "./announcement_editor.vue?vue&type=style&index=0&id=357f0d7c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__